<template>
  <div class="bg" id="navLi" v-bind:class="{ Domfixed: trueFixed }">
    <div class="container">
      <div class="navbar">
        <div class="navbar-inner">
          <ul class="nav nav-pills">
            <li v-bind:class="{ active: nav('homeContent') }"><router-link to="/">优势介绍</router-link></li>
            <li class="dropdown" :class="{ active: nav('homeMortgageContent') || nav('homeReplaceContent') || nav('homeLoanContent') }">
              <a href="#">{{ servIntroNav }}<span class="caret"></span></a>
              <ul class="dropdown-menu">
                <li @click="servIntroClick(0)"><router-link to="/mortgage">仓单质押</router-link></li>
                <li @click="servIntroClick(1)"><router-link to="/replace" >代检代发</router-link></li>
                <li @click="servIntroClick(2)"><router-link to="/loan">易木贷(信贷)</router-link></li>
              </ul>
            </li>
            <li><a href="http://mall.emulian.com/">木材商城</a></li>
           <!--  <li>
              <a href="javascript:;" @click=''>木材商城
              </a>
            </li> -->
            <li class="dropdown" :class="{ active: navActive() }" >
              <a href="#">{{ firmIntroNav }}<span class="caret"></span></a>
              <ul class="dropdown-menu">
                <li @click="firmIntroClick(0)"><router-link to="/firm-intro">公司介绍</router-link></li>
                <li @click="firmIntroClick(1)"><router-link to="/join-us/market">加入我们</router-link></li>
                <li @click="firmIntroClick(2)"><router-link to="/contact">联系我们</router-link></li>
              </ul>
            </li>
            <li v-bind:class="{ active: nav('homeApp') }" ><router-link to="/app">下载APP</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//  import { mapGetters } from 'vuex'
 import $ from 'jquery'
  export default {
    name: 'homeNavigator',
//    computed: {
//      ...mapGetters([
//      ])
//    },
    methods: {
      getTop: function () {
        let scrollTOP = $(document).scrollTop()
        // let domY = $('#navLi').offset().top
          if (scrollTOP > 160) {
            this.trueFixed = true;
          } else {
            this.trueFixed = false;
          }
        // console.log(scrollTOP)
      },
      nav: function (name) {
        return name === this.$route.name
      },
      navPath: function () {
        let parentPath = this.$route.path.split('/')[1]
        switch (parentPath) {
          case 'firm-intro': {
            return '公司介绍'
          }
          case 'join-us': {
            return '加入我们'
          }
          case 'contact': {
            return '联系我们'
          }
        }
      },
      navActive: function () {
        let path = this.$route.path.split('/')[1]
        return path === 'firm-intro' || path === 'join-us' || path === 'contact'
      },
      servIntroClick: function (servId) {
        switch (servId) {
          case 0: {
            this.servIntroNav = '仓单质押'
            break
          }
          case 1: {
            this.servIntroNav = '代检代发'
            break
          }
          case 2: {
            this.servIntroNav = '易木贷(信贷)'
            break
          }
        }
      },
      firmIntroClick: function (firmIntroId) {
        switch (firmIntroId) {
          case 0: {
            this.firmIntroNav = '公司介绍'
            break
          }
          case 1: {
            this.firmIntroNav = '加入我们'
            break
          }
          case 2: {
            this.firmIntroNav = '联系我们'
            break
          }
        }
      }
    },
    data () {
      return {
        servIntroNav: '服务介绍',
        firmIntroNav: '关于我们',
        trueFixed: false
//        isServNavActive: '',
//        isFirmNavActive: ''
      }
    },
    watch: {
      $route: {
        handler: function () {
          let path = this.$route.path.split('/')[1]
          if (!(path === 'mortgage' || path === 'replace' || path === 'loan')) {
            this.servIntroNav = '服务介绍'
          }
          if (!(path === 'firm-intro' || path === 'join-us' || path === 'contact')) {
            this.firmIntroNav = '关于我们'
          }
        }
      }
    },
    created: function () {
      window.addEventListener('scroll', this.getTop)
      this.getTop()
      let path = this.$route.path.split('/')[1]
      console.log('created')
      switch (path) {
        case 'mortgage': {
          this.servIntroNav = '仓单质押'
          break
        }
        case 'replace': {
          this.servIntroNav = '代检代发'
          break
        }
        case 'loan': {
          this.servIntroNav = '易木贷(信贷)'
          break
        }
        case 'firm-intro': {
          this.servIntroNav = '公司介绍'
          break
        }
        case 'join-us': {
          this.servIntroNav = '加入我们'
          break
        }
        case 'contact': {
          this.servIntroNav = '联系我们'
          break
        }
      }
      if (!(path === 'mortgage' || path === 'replace' || path === 'loan')) {
        this.servIntroNav = '服务介绍'
      }
      if (!(path === 'firm-intro' || path === 'join-us' || path === 'contact')) {
        this.firmIntroNav = '关于我们'
      }
    }
  }
</script>

<style scoped>

  .bg {
    background-color: rgba(69, 180, 88, 1);
    display: block;
    text-align: center;
    width: 100%;
    z-index: 1000;
  }
  .Domfixed{
    position: fixed;
    top: 0;
  }
  .container {
    width: 980px;
    height: inherit;
    margin: auto;
    padding: 0;
    font-size: 16px;
  }
  .navbar .navbar-inner {
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .navbar .nav > li .dropdown-menu {
    margin: 0;
  }
  .navbar .nav > li:hover .dropdown-menu {
    display: block;
    padding-bottom: 0;
  }

  .navbar {
    height: inherit;
    padding: 0;
    margin: 0;
    border-radius: 0;
    border: none;
    min-height: 0;
  }
  .nav .nav-pills {
    height: inherit;
  }
  .active {
    background-color: rgb(255, 255, 255);
    color: rgb(19, 174, 47);
  }
  .nav-pills>li.active>a, .nav-pills>li.active>a:focus, .nav-pills>li.active>a:hover {
    background-color: rgb(255, 255, 255);
    color: rgb(19, 174, 47);
  }

  .nav>li {
    margin: 0;
    padding: 0;
    width: 160px;
    height: 40px;
    line-height: 40px;
  }
  .nav>li>a {
    position: relative;
    display: block;
    line-height: 40px;
    font-size: 18px;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }
  .nav>li>a:focus, .nav>li>a:hover {
    text-decoration: none;
    background-color: rgba(255, 255, 255, 1);
    color: rgb(19, 174, 47);
  }
  .dropdown-menu {
    width: 160px;
    padding: 0;
    margin: 0;
    border-radius: 0;
    border: none;
    text-align: center;
    font-size: 16px;
  }
  .dropdown-menu>li {
    width: inherit;
    border-top: solid;
    border-width: 1px;
    border-color: rgb(226,226,226);
    height: 40px;
    line-height: 40px;
  }
  .dropdown-menu>li>a {
    width: inherit;
    line-height: 40px;
    /*display: block;*/
    padding: 0;
    clear: both;
    font-weight: 400;
    color: #333;
    white-space: nowrap;background-color: rgb(255,255,255);
  }
  .dropdown-menu>li>a:focus, .dropdown-menu>li>a:hover {
    text-decoration: none;
    /*background-color: rgb(255,255,255);*/
    color: rgb(19, 174, 47);;
  }
  a {
    height: inherit;
    color: rgb(255, 255, 255);
  }
  ul {
    height: inherit;
  }
  .nav-pills>li>a {
    border-radius: 0;
  }
  .clear{
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// HomeNavigator.vue?63d5442e